export const CONTENT_FRAME_ID = 'appTemplateContentFrame';

export const SIDEBAR = {
  widthExpanded: 204,
  widthCollapsed: 54,
  widthMobile: 208,
  transitionDuration: 230,
  sectionTitleMaxWidth: 200,
};

export const TOPBAR = { height: 48 };
export const BOTTOMBAR = { height: 52 };

export const LIST_PAGE_HEADER = {
  heightDesktop: 64,
  heightMobile: 80,
};
